import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import Page from '../../components/Page';

export default function Home() {
  const { cliente } = useAuthContext();
  const navigate = useNavigate();

  // ✅ PASSO 1: Verificamos se o usuário é admin, da mesma forma que no menu.
  // Se o cliente não existir ou não tiver a flag, isAdmin será false.
  const isAdmin = cliente?.isAdmin ?? false;

  const buttonStyle = {
    backgroundColor: '#00678D',
    color: '#fff',
    fontWeight: 600,
    fontSize: 16,
    borderRadius: 1,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#00678D',
      boxShadow: 'none',
    },
    minWidth: 190,
  };

  return (
    <Page title="Home | Tecnozap">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <ChatBubbleOutlineIcon sx={{ fontSize: 88, color: '#1976d2', mb: 3 }} />
        <h2 style={{ fontWeight: 500, fontSize: 26, marginBottom: 8 }}>
          Inicie uma conversa
        </h2>
        <p style={{ color: '#888', marginBottom: 32 }}>
          Você não tem nenhuma conversa aberta ainda.
        </p>

        {/* ✅ PASSO 2: Usamos a variável `isAdmin` para renderizar os botões condicionalmente. */}
        {/* Este bloco <Stack> só vai aparecer na tela se `isAdmin` for true. */}
        {isAdmin && (
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              size="large"
              sx={buttonStyle}
              onClick={() => navigate('/app/dashboard')}
            >
              Dashboard
            </Button>
            <Button
              variant="contained"
              size="large"
              sx={buttonStyle}
              onClick={() => navigate('/app/users')}
            >
              Gerenciar Usuários
            </Button>
          </Stack>
        )}
      </div>
    </Page>
  );
}
